export default {
  default: () => import("D:/oneway/machine-web/layouts/default.vue").then(m => m.default || m)
}